/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} One_Off_Payment_DescriptionInputs */

const en_one_off_payment_description = /** @type {(inputs: One_Off_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One-time purchase`)
};

const id_one_off_payment_description = /** @type {(inputs: One_Off_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pembelian sekali bayar`)
};

const ms_one_off_payment_description = /** @type {(inputs: One_Off_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pembelian sekali`)
};

const ca_one_off_payment_description = /** @type {(inputs: One_Off_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compra única`)
};

const cs_one_off_payment_description = /** @type {(inputs: One_Off_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jednorázový nákup`)
};

const da_one_off_payment_description = /** @type {(inputs: One_Off_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Engangskøb`)
};

const de_one_off_payment_description = /** @type {(inputs: One_Off_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einmaliger Kauf`)
};

const et_one_off_payment_description = /** @type {(inputs: One_Off_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ühekordne ost`)
};

const es_one_off_payment_description = /** @type {(inputs: One_Off_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compra única`)
};

const fr_one_off_payment_description = /** @type {(inputs: One_Off_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Achat unique`)
};

const hr_one_off_payment_description = /** @type {(inputs: One_Off_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jednokratna kupnja`)
};

const it_one_off_payment_description = /** @type {(inputs: One_Off_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acquisto una tantum`)
};

const lv_one_off_payment_description = /** @type {(inputs: One_Off_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vienreizējs pirkums`)
};

const lt_one_off_payment_description = /** @type {(inputs: One_Off_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vienkartinis pirkinys`)
};

const hu_one_off_payment_description = /** @type {(inputs: One_Off_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egyszeri vásárlás`)
};

const nl_one_off_payment_description = /** @type {(inputs: One_Off_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eenmalige aankoop`)
};

const nb_one_off_payment_description = /** @type {(inputs: One_Off_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Engangskjøp`)
};

const pl_one_off_payment_description = /** @type {(inputs: One_Off_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zakup jednorazowy`)
};

const pt_one_off_payment_description = /** @type {(inputs: One_Off_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compra única`)
};

const ro_one_off_payment_description = /** @type {(inputs: One_Off_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Achiziție unică`)
};

const sk_one_off_payment_description = /** @type {(inputs: One_Off_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jednorazový nákup`)
};

const sl_one_off_payment_description = /** @type {(inputs: One_Off_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enkratni nakup`)
};

const fi_one_off_payment_description = /** @type {(inputs: One_Off_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kertaluonteinen osto`)
};

const sv_one_off_payment_description = /** @type {(inputs: One_Off_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Engångsköp`)
};

const vi_one_off_payment_description = /** @type {(inputs: One_Off_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mua một lần`)
};

const tr_one_off_payment_description = /** @type {(inputs: One_Off_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tek seferlik satın alma`)
};

const el_one_off_payment_description = /** @type {(inputs: One_Off_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Εφάπαξ αγορά`)
};

const bg_one_off_payment_description = /** @type {(inputs: One_Off_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Еднократна покупка`)
};

const ru_one_off_payment_description = /** @type {(inputs: One_Off_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Разовая покупка`)
};

const sr_one_off_payment_description = /** @type {(inputs: One_Off_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Једнократна куповина`)
};

const uk_one_off_payment_description = /** @type {(inputs: One_Off_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Одноразова покупка`)
};

const ka_one_off_payment_description = /** @type {(inputs: One_Off_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ერთჯერადი შეძენა`)
};

const hi_one_off_payment_description = /** @type {(inputs: One_Off_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एक बार की खरीद`)
};

const th_one_off_payment_description = /** @type {(inputs: One_Off_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การซื้อแบบครั้งเดียว`)
};

const ko_one_off_payment_description = /** @type {(inputs: One_Off_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`일회성 구매`)
};

const zh_tw_one_off_payment_description = /** @type {(inputs: One_Off_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一次性購買`)
};

const ja_one_off_payment_description = /** @type {(inputs: One_Off_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`買い切り購入`)
};

/** @type {(inputs: One_Off_Payment_DescriptionInputs) => LocalizedString} */
const zh_one_off_payment_description = en_one_off_payment_description;

/**
* | output |
* | --- |
* | "One-time purchase" |
*
* @param {One_Off_Payment_DescriptionInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const one_off_payment_description = /** @type {((inputs?: One_Off_Payment_DescriptionInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<One_Off_Payment_DescriptionInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_one_off_payment_description(inputs)
	if (locale === "ms") return ms_one_off_payment_description(inputs)
	if (locale === "ca") return ca_one_off_payment_description(inputs)
	if (locale === "cs") return cs_one_off_payment_description(inputs)
	if (locale === "da") return da_one_off_payment_description(inputs)
	if (locale === "de") return de_one_off_payment_description(inputs)
	if (locale === "et") return et_one_off_payment_description(inputs)
	if (locale === "es") return es_one_off_payment_description(inputs)
	if (locale === "fr") return fr_one_off_payment_description(inputs)
	if (locale === "hr") return hr_one_off_payment_description(inputs)
	if (locale === "it") return it_one_off_payment_description(inputs)
	if (locale === "lv") return lv_one_off_payment_description(inputs)
	if (locale === "lt") return lt_one_off_payment_description(inputs)
	if (locale === "hu") return hu_one_off_payment_description(inputs)
	if (locale === "nl") return nl_one_off_payment_description(inputs)
	if (locale === "nb") return nb_one_off_payment_description(inputs)
	if (locale === "pl") return pl_one_off_payment_description(inputs)
	if (locale === "pt") return pt_one_off_payment_description(inputs)
	if (locale === "ro") return ro_one_off_payment_description(inputs)
	if (locale === "sk") return sk_one_off_payment_description(inputs)
	if (locale === "sl") return sl_one_off_payment_description(inputs)
	if (locale === "fi") return fi_one_off_payment_description(inputs)
	if (locale === "sv") return sv_one_off_payment_description(inputs)
	if (locale === "vi") return vi_one_off_payment_description(inputs)
	if (locale === "tr") return tr_one_off_payment_description(inputs)
	if (locale === "el") return el_one_off_payment_description(inputs)
	if (locale === "bg") return bg_one_off_payment_description(inputs)
	if (locale === "ru") return ru_one_off_payment_description(inputs)
	if (locale === "sr") return sr_one_off_payment_description(inputs)
	if (locale === "uk") return uk_one_off_payment_description(inputs)
	if (locale === "ka") return ka_one_off_payment_description(inputs)
	if (locale === "hi") return hi_one_off_payment_description(inputs)
	if (locale === "th") return th_one_off_payment_description(inputs)
	if (locale === "ko") return ko_one_off_payment_description(inputs)
	if (locale === "zh") return zh_one_off_payment_description(inputs)
	if (locale === "zh-tw") return zh_tw_one_off_payment_description(inputs)
	if (locale === "ja") return ja_one_off_payment_description(inputs)
	return en_one_off_payment_description(inputs)
});